export default "__VITE_ASSET__CR8ZCQpO__"